import { Extension } from "@codemirror/state";
import { EditorView } from "@codemirror/view";
import { uiStore } from "@/store/store";

// Focus the editor when the C S S shortcut is triggered

export function createKeyboardFocus(): Extension {
  return EditorView.updateListener.of(update => {
    // Check if focus was triggered by keyboard action
    if (uiStore.keyboardTriggeredActions.focusCodeMirror === "pending") {
      uiStore.setKeyboardTriggeredActions({
        ...uiStore.keyboardTriggeredActions,
        focusCodeMirror: null
      });

      // Focus the editor on next tick to ensure DOM is ready
      setTimeout(() => {
        update.view.focus();
      }, 0);
    }
  });
}
